/** The single source of truth for the bar's order. */
export const DESTINATIONS = [
  { to: "/home", label: "Home" },
  { to: "/ledger", label: "Ledger" },
  { to: "/", label: "Add", raised: true },
  { to: "/analytics", label: "Trends" },
  { to: "/settings", label: "Settings" },
] as const;
export type TabDirection = "forward" | "back";
